import { get, post, put } from ".";

export const getAllTrip = () => {
  return get(`/api/group/trip/myTrips`, true);
};
export const getTripGroup = (groupId, pageIndex, pageSize) => {
  return get(
    `/api/admin/trip/getGroupsTripsWithPagination/${groupId}?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    true,
  );
};
export const updateGroupTrip = (tripId, data) => {
  return put(`/api/group/trip/update/${tripId}`, true, data);
};
export const storeArea = (tripId, data) => {
  return post(`/api/area/store/${tripId}`, true, data);
};
